import React from 'react';
import { API } from 'aws-amplify';
import { toast } from 'react-toastify';
import Select from "react-select";
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';

import InputCell from "@/common/form/InputCell";
import { TIMEZONES } from "@/utils/utils";

const TENANT_LABELS = [
    { key: 'engage',   title: 'Engage' },
    { key: 'ready',    title: 'Ready' },
    { key: 'pss',      title: 'PSS' },
    { key: 'churn',    title: 'Churn' },
    { key: 'internal', title: 'Internal' },
];

export default function CreateTenant({ onSuccess }) {

    const companyNameRef = React.createRef()
    const salesforceIdRef = React.createRef()
    const firstNameRef = React.createRef()
    const lastNameRef = React.createRef()
    const emailRef = React.createRef()
    const passwordRef = React.createRef()
    const [timezoneObj, setTimezoneObj] = React.useState(TIMEZONES[0]);
    const siteKeyInternalRef = React.createRef()
    const globalEmployerIdRef = React.createRef()
    const [labels, setLabels] = React.useState({ engage: false, ready: false, pss: false, churn: false, internal: false });
    const toggleLabel = (key) => setLabels(prev => ({ ...prev, [key]: !prev[key] }));

    const onTimezoneChange = (obj, action) => {
        setTimezoneObj(obj);
    }

    async function submitSignUp(e) {
        e.preventDefault();
        let signUpInfo = {
            companyName: companyNameRef.current.value,
            salesforceId: salesforceIdRef.current.value,
            firstName: firstNameRef.current.value,
            lastName: lastNameRef.current.value,
            email: emailRef.current.value,
            password: passwordRef.current.value,
            timezoneName: timezoneObj.value,
            phone: null,
            siteKeyInternal: siteKeyInternalRef.current.value === '' ? null: siteKeyInternalRef.current.value,
            globalEmployerId: globalEmployerIdRef.current.value === '' ? null: globalEmployerIdRef.current.value,
            ...labels
        };

        await API.post('Core', '/api/v1/support-tools/tenants/create', { body: signUpInfo })
            .then(() => {
                toast("Successfully created a new tenant!", { position: "top-center", type: "success" });
                onSuccess();
            })
            .catch((err) => {
                let errorMessage = err.response.data.message;
                try{
                    let [emptyTenantMessage]= JSON.parse(errorMessage);
                    toast(emptyTenantMessage, { position: "top-center", type: "error" });
                }
                catch (e) {
                    toast(errorMessage, { position: "top-center", type: "error" });
                }
            });
    }

    return (
        <div>
            <div className="content">
                <div className="tableView">
                    <div className="tableSection">
                        <InputCell
                            placeholder={"Ambulance Corp"}
                            required
                            id="firstName"
                            label="Company Name"
                            inputRef={companyNameRef}
                        />
                    </div>

                    <div className="tableSection">
                        <div className="sectionTitle">Timezone</div>
                        <Select className="cell selectCell" classNamePrefix="selectCell"
                                onChange={onTimezoneChange}
                                defaultValue={timezoneObj}
                                value={timezoneObj}
                                options={TIMEZONES}
                        />

                    </div>

                    <div className="tableSection">
                        <InputCell
                            placeholder={"Salesforce Id"}
                            label="Salesforce Id"
                            inputRef={salesforceIdRef}
                        />
                    </div>

                    <div className="tableSection">
                        <InputCell
                            placeholder={"John"}
                            required
                            id="firstName"
                            label="First Name"
                            inputRef={firstNameRef}
                        />

                        <InputCell
                            placeholder={"Smith"}
                            required
                            id="lastName"
                            label="Last Name"
                            inputRef={lastNameRef}
                        />
                    </div>

                    <div className="tableSection">
                        <InputCell
                            placeholder={"name@domain.com"}
                            required
                            inputProps={{
                                autocomplete: "username"
                            }}
                            id="email"
                            label="Email"
                            inputRef={emailRef}
                        />

                        <InputCell
                            required
                            id="password"
                            label="Optional Password"
                            inputRef={passwordRef}
                            type="password"
                        />

                        <div className="cellFootnote">
                            <b>OPTIONAL</b> <br/>
                            * If you set the password then you will need to share it with the end user. They will be
                            asked to verify their email address on first login. Password must have at least 1 uppercase,
                            1 lower case, 1 number, and 1 special character.<br/>
                            * If you <b>DO NOT</b> set a password then the system will generate one and email the user.
                        </div>
                    </div>

                    <div className="tableSection">
                        <div className="sectionTitle">Foundation/PowerSSO</div>
                        <InputCell
                            id="siteKeyInternal"
                            label="Site Key Internal"
                            inputRef={siteKeyInternalRef}
                        />
                        <InputCell
                            id="globalEmployerId"
                            label="Global Employer ID"
                            inputRef={globalEmployerIdRef}
                        />
                    </div>

                    <div className="tableSection">
                        <div className="sectionTitle" id="tenantTypeLabelCreate">Tenant Type</div>
                        <FormGroup row role="group" aria-labelledby="tenantTypeLabelCreate">
                            {TENANT_LABELS.map(({ key, title }) => (
                                <FormControlLabel
                                    key={key}
                                    label={title}
                                    control={
                                        <Checkbox
                                            checked={labels[key]}
                                            onChange={() => toggleLabel(key)}
                                            inputProps={{ 'aria-label': title }}
                                        />
                                    }
                                />
                            ))}
                        </FormGroup>
                    </div>

                    <div className="tableSection">
                        <div
                            className={`button large tintProminent`}
                            onClick={submitSignUp}
                            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); submitSignUp(e); } }}
                            role="button"
                            tabIndex={0}
                            aria-label="Create Tenant"
                        >
                            <div className="title">Create Tenant</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}